window.storeTheme = window.storeTheme || ({} as StoreTheme);
const handleProductLayout = () => {
  const $body = $('body');
  const $productSpecification = $($('script#productSpecification').text());

  let measureType;
  const init = () => {
    measureTypeBodyClass();
    createMainSlideTemplate();
    makeMainImagesSlider();
    createTableNutritionalInfo();
    setupContentBlocks();
    buyTogether();
    complementImagesDesktop();
    customFlagPdp(window.skuJson.skus[0].sku);
    identifyProductSwifteVocePrice();
  };

  const complementImagesDesktop = () => {
    const images = $('.product-container .desktop li a img').clone().slice(1);
    if (images.length) {
      const $html = $(`<div class="row d-none d-md-flex mt-4 desktop rnk-componente-midias" />`);
      $html.html(
        Array.from(images).map(function (e) {
          const $img = $(e);
          return `<div class="col-6 mb-4"><img class="img-fluid" src="${$img.attr(
            'src',
          )}" width="320" height="320" alt="Imagem" /></div>`;
        }),
      );

      $html.insertAfter('.apresentacao');
    }
  };

  /**
   * monta template para imagens de produto na parte mobile
   *
   * @returns string
   */
  const createMainSlideTemplate = () => {
    const getSplideSlideTemapleMobile = () => {
      const thumbs = $('.product-container .desktop li a img');
      const splideSlide = [];

      Array.from(thumbs).forEach((ele) => {
        const src = $(ele).attr('src');

        const html = `
        <li class="comp-ProductImage-item splide__slide">
          <button class="w-100 position-relative comp-ProductImage-item-button p-0 align-top">
            <div class="w-100 position-relative d-table comp-ProductImage-image">
              <img class="comp-ProductImage-image-item" src=${src} />
            </div>
          </button>
        </li>`;

        splideSlide.push(html);
      });

      return splideSlide;
    };
    const imageContainer = $('.mobile-image-container');
    const splideSlide = getSplideSlideTemapleMobile();
    imageContainer.find('.splide__list').append(splideSlide.join(''));
  };

  /**
   * Aplica slider no bloco de imagens, principalemnte para aplicar em layout mobile
   */
  const makeMainImagesSlider = () => {
    const config = {
      perPage: 1,
      arrows: false,
      speed: 1000,
      autoplay: false,
      type: 'loop',
      gap: '0',
      lazyLoad: 'nearby',
      pauseOnHover: false,
      pauseOnFocus: false,
      width: '100vw',
    } as SplideOptions;

    const $slider = document.querySelector('.mobile-image-container .splide');

    const slider = window.storeTheme.helpers.slider($slider, config);
    slider.mount();
  };

  /**
   * Adiciona informações para tabela de informações nutricionais de acordo com atributos do produto
   */
  const createTableNutritionalInfo = () => {
    // VERIFICAÇÃO SE TABELA POSSUI VALORES PREENCHIDOS
    function verificaCamposPreenchidos(obj) {
      for (let prop in obj) {
        for (let field in obj[prop]) {
          if (obj[prop][field] !== '') {
            return true;
          }
        }
      }
      return false;
    };

    try {
      // ESPECIFICAÇÕES DO PRODUTO
      let $productSpecificationTables = $($('script#productSpecification').html());

      // LISTA DE COMPONENTES DA TABELA
      const listaItemsTabelaSwift = ['Carboidratos', 'Fibra-Alimentar', 'Gorduras-Saturadas', 'Gorduras-Totais', 'Gorduras-Trans', 'Proteinas', 'Sodio', 'Valor-Energetico', 'Peso-total-em-g', 'Acucares-Adicionados', 'Acucares-Totais'];

      // OBJETO COM DADOS TABELA PRETA DE BRANCA
      const dadosTabelaNutricional = {
        valueField: {},
        valueFieldVD: {},
        valueFieldVT: {},
        valueFieldPorcao: {
          ['Porcoes-Por-Embalagem']: '',
          ['Tabela-Nutricional-Porcao']: ''
        },
        valueFieldInfoAnexada: {
          ['Informacoes-Anexadas']: '',
        },
      };
      // OBJETO COM DADOS TABELA COLORIDA
      const dadosTabelaNutricionalEstilizada = {
        valueField: {},
        valueFieldVD: {},
        valueFieldVT: {},
        valueFieldPorcao: {
          ['Porcoes-Por-Embalagem']: '',
          ['Tabela-Nutricional-Porcao']: ''
        },
        valueFieldInfoAnexada: {
          ['Informacoes-Anexadas']: '',
        },
      };

      // ITERAÇÃO PARA ALOCAR OS COMPONENTES NO OBJETO
      for (const item of listaItemsTabelaSwift) {
        if (item == 'Peso-total-em-g') {
          dadosTabelaNutricional.valueFieldVT[item] = '';
          dadosTabelaNutricional.valueField[item] = '';
          dadosTabelaNutricionalEstilizada.valueFieldVT[item] = '';
          dadosTabelaNutricionalEstilizada.valueField[item] = '';
        } else {
          dadosTabelaNutricional.valueField[item] = '';
          dadosTabelaNutricional.valueFieldVD[item] = '';
          dadosTabelaNutricional.valueFieldVT[item] = '';
          dadosTabelaNutricionalEstilizada.valueField[item] = '';
          dadosTabelaNutricionalEstilizada.valueFieldVD[item] = '';
          dadosTabelaNutricionalEstilizada.valueFieldVT[item] = '';
        }
      }

      // CONSUMO DE DADOS DO DOM PARA A TABELA PRETA E BRANCA
      const getDataFromDomSwift = () => {
        let $trTabelaNutricionalSwift = $productSpecification.find('.Tabela-Nutricional-Swift tr');
        let $vtextdValueField = $trTabelaNutricionalSwift.find('td.value-field');
        $vtextdValueField.each((i, tdValueField) => {          
          if (tdValueField.classList[1].includes(dadosTabelaNutricional.valueField[tdValueField.classList[1]])) {
            dadosTabelaNutricional.valueField[tdValueField.classList[1]] = $(tdValueField).html();
          } else {
            dadosTabelaNutricional.valueField[tdValueField.classList[1]] = '**'
          }
        });

        let $trTabelaNutricionalSwiftVD = $productSpecification.find('.Tabela-Nutricional-Swift-VD- tr');
        let $vtextdValueFieldVD = $trTabelaNutricionalSwiftVD.find('td.value-field');
        $vtextdValueFieldVD.each((i, tdValueFieldVD) => {
          let classNameVD = tdValueFieldVD.classList[1].replace('-VD-', '')
          if (classNameVD.includes(dadosTabelaNutricional.valueFieldVD[classNameVD])) {
            dadosTabelaNutricional.valueFieldVD[classNameVD] = $(tdValueFieldVD).html();
          } else {
            dadosTabelaNutricional.valueFieldVD[classNameVD] = '**';
          }
        });

        let $trTabelaNutricionalSwiftVT = $productSpecification.find('.Tabela-Nutricional-Valores-Totais-em-g-Swift tr');
        let $vtextdValueFieldVT = $trTabelaNutricionalSwiftVT.find('td.value-field');
        $vtextdValueFieldVT.each((i, tdValueFieldVT) => {
          let classNameVT = tdValueFieldVT.classList[1].replace('-VT', '');
          if (classNameVT.includes(dadosTabelaNutricional.valueFieldVT[classNameVT])) {
            dadosTabelaNutricional.valueFieldVT[classNameVT] = $(tdValueFieldVT).html();
          } else {
            dadosTabelaNutricional.valueFieldVT[classNameVT] = '**';
          }
        });

        let $trTabelaNutricionalSwiftPorcao = $productSpecification.find('.Tabela-Nutricional-Porcao-Swift tr');
        let $vtextdValueFieldPorcao = $trTabelaNutricionalSwiftPorcao.find('td.value-field');
        $vtextdValueFieldPorcao.each((i, tdValueFieldPorcao) => {
          let classNamePorcao = tdValueFieldPorcao.classList[1];
          if (classNamePorcao.includes(dadosTabelaNutricional.valueFieldPorcao[classNamePorcao])) {
            dadosTabelaNutricional.valueFieldPorcao[classNamePorcao] = $(tdValueFieldPorcao).html();
          } else {
            dadosTabelaNutricional.valueFieldPorcao[classNamePorcao] = '**';
          }
        });

        let $trTabelaNutricionalSwiftInfoAnexada = $productSpecification.find('.Informacoes-Anexadas-a-Tabela-Nutricional-Swift tr');
        let $vtextdValueFieldInfoAnexada = $trTabelaNutricionalSwiftInfoAnexada.find('td.value-field');
        $vtextdValueFieldInfoAnexada.map((i, tdValueFieldInfoAnexada) => {
          let classNameInfoAnexada = tdValueFieldInfoAnexada.classList[1];
          if (classNameInfoAnexada.includes(dadosTabelaNutricional.valueFieldInfoAnexada[classNameInfoAnexada])) {
            dadosTabelaNutricional.valueFieldInfoAnexada[classNameInfoAnexada] = $(tdValueFieldInfoAnexada).html();
          } else {
            dadosTabelaNutricional.valueFieldInfoAnexada[classNameInfoAnexada] = '**';
          }
        });
      };
      getDataFromDomSwift();

      // CONSUMO DE DADOS DO DOM PARA A TABELA COLORIDA
      const getDataFromDomSwiftTabelaNova = () => {
        let $trTabelaNutricionalSwift = $productSpecificationTables.find('.Tabela-Nutricional tr');
        let $vtextdValueField = $trTabelaNutricionalSwift.find('td.value-field');
        $vtextdValueField.each((i, tdValueField) => {          
          let classNameField = tdValueField.classList[1]
            .replace('-kcal-', '')
            .replace('-g-', '')
            .replace('-mg-', '')
            .replace('adicionados', 'Adicionados')
            .replace('-energetico', '-Energetico')
            .replace('-totais', '-Totais')
            .replace('-saturadas', '-Saturadas')
            .replace('-trans', '-Trans')
            .replace('Fibras-alimentares', 'Fibra-Alimentar');

          if (classNameField.includes(dadosTabelaNutricionalEstilizada.valueField[classNameField])) {
            dadosTabelaNutricionalEstilizada.valueField[classNameField] = $(tdValueField).html();
          } else {
            dadosTabelaNutricionalEstilizada.valueField[classNameField] = '**'
          };

        });

        let $trTabelaNutricionalSwiftVD = $productSpecificationTables.find('.Tabela-Nutricional-VD-- tr');
        let $vtextdValueFieldVD = $trTabelaNutricionalSwiftVD.find('td.value-field');
        $vtextdValueFieldVD.each((i, tdValueField) => {
          let classNameFieldVD = tdValueField.classList[1]
            .replace('-VD--', '')
            .replace('Fibras-alimentares', 'Fibra-Alimentar')
            .replace('adicionados', 'Adicionados')

          if (classNameFieldVD.includes(dadosTabelaNutricionalEstilizada.valueFieldVD[classNameFieldVD])) {
            dadosTabelaNutricionalEstilizada.valueFieldVD[classNameFieldVD] = $(tdValueField).html();
          } else {
            dadosTabelaNutricionalEstilizada.valueFieldVD[classNameFieldVD] = '**'
          };
        });

        let $trTabelaNutricionalSwiftVT = $productSpecificationTables.find('.Valores-totais-em-g- tr');
        let $vtextdValueFieldVT = $trTabelaNutricionalSwiftVT.find('td.value-field');
        $vtextdValueFieldVT.each((i, tdValueField) => {
          let classNameFieldVT = tdValueField.classList[1]
            .replace('energetico', 'Energetico')
            .replace('totais', 'Totais')
            .replace('adicionados', 'Adicionados')
            .replace('saturadas', 'Saturadas')
            .replace('trans', 'Trans')
            .replace('Fibras', 'Fibra')
            .replace('alimentares', 'Alimentar')

          if (classNameFieldVT.includes(dadosTabelaNutricionalEstilizada.valueFieldVT[classNameFieldVT])) {
            dadosTabelaNutricionalEstilizada.valueFieldVT[classNameFieldVT] = $(tdValueField).html();
          } else {
            dadosTabelaNutricionalEstilizada.valueFieldVT[classNameFieldVT] = '**'
          };
        });

        let $trTabelaNutricionalSwiftInfoAnexada = $productSpecificationTables.find('.Informacoes-Anexadas-a-Tabela-Nutricional tr');
        let $vtextdValueFieldInfoAnexada = $trTabelaNutricionalSwiftInfoAnexada.find('td.value-field');
        $vtextdValueFieldInfoAnexada.each((i, tdValueField) => {
          let classNameFieldInfoAnexada = tdValueField.classList[1]
            .replace('Tabela-Nutricional-Informacoes-Anexas', 'Informacoes-Anexadas');

          if (classNameFieldInfoAnexada.includes(dadosTabelaNutricionalEstilizada.valueFieldInfoAnexada[classNameFieldInfoAnexada])) {
            dadosTabelaNutricionalEstilizada.valueFieldInfoAnexada[classNameFieldInfoAnexada] = $(tdValueField).html();
          } else {
            dadosTabelaNutricionalEstilizada.valueFieldInfoAnexada[classNameFieldInfoAnexada] = '**'
          };
        });

        let $trTabelaNutricionalSwiftPorcao = $productSpecificationTables.find('.Tabela-Nutricional-Porcao tr');
        let $vtextdValueFieldPorcao = $trTabelaNutricionalSwiftPorcao.find('td.value-field');
        $vtextdValueFieldPorcao.each((i, tdValueField) => {
          let classNameFieldPorcao = tdValueField.classList[1]
            .replace('Porcoes-por-embalagem', 'Porcoes-Por-Embalagem');

          if (classNameFieldPorcao.includes(dadosTabelaNutricionalEstilizada.valueFieldPorcao[classNameFieldPorcao])) {
            dadosTabelaNutricionalEstilizada.valueFieldPorcao[classNameFieldPorcao] = $(tdValueField).html();
          } else {
            dadosTabelaNutricionalEstilizada.valueFieldPorcao[classNameFieldPorcao] = '**'
          };
        });
      };
      getDataFromDomSwiftTabelaNova();

      // TABELAS
      const $table = $(`
      <table>
          <caption class="d-none">
              Tabela Informação Nutricional
          </caption>
          <thead>
              <tr>
                  <th colspan="5" class="name-field-porcoes">
                      <div>
                          <span>Porções por embalagem: ${dadosTabelaNutricional.valueFieldPorcao["Porcoes-Por-Embalagem"] == '' ? '' : dadosTabelaNutricional.valueFieldPorcao["Porcoes-Por-Embalagem"]}</span>
                      </div>
                      <div class="bottom_line">
                        <span>Porção: ${dadosTabelaNutricional.valueFieldPorcao["Tabela-Nutricional-Porcao"] == '' ? '' : dadosTabelaNutricional.valueFieldPorcao["Tabela-Nutricional-Porcao"]}</span>
                      </div>
                  </th>
              </tr>
              <tr class="last-line-header">
                  <th colspan="3" class="name-field-qtd-por-porcao"></th>
                  <th class="name-field">
                      <div>${dadosTabelaNutricional.valueField["Peso-total-em-g"] == '' ? '' : dadosTabelaNutricional.valueField["Peso-total-em-g"]}</div>
                  </th>
                  <th class="name-field-vt">
                      <div>${dadosTabelaNutricional.valueFieldVT["Peso-total-em-g"] == '' ? '' : dadosTabelaNutricional.valueFieldVT["Peso-total-em-g"]}</div>
                  </th>
                  <th class="name-field-vd">
                      <div>%VD*</div>
                  </th>
              </tr>
          </thead>
          <tbody>
            <tr>
                <td colspan="3" class="value-name">Valor energético (kcal)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Valor-Energetico'] == '' ? '' : dadosTabelaNutricional.valueField['Valor-Energetico']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Valor-Energetico'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Valor-Energetico']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Valor-Energetico'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Valor-Energetico']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name">Carboidratos (g)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Carboidratos'] == '' ? '' : dadosTabelaNutricional.valueField['Carboidratos']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Carboidratos'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Carboidratos']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Carboidratos'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Carboidratos']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name sub-value-name">Açúcares totais (g)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Acucares-Totais'] == '' ? '' : dadosTabelaNutricional.valueField['Acucares-Totais']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Acucares-Totais'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Acucares-Totais']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Acucares-Totais'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Acucares-Totais']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name third-value-name">Açúcares adicionados (g)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Acucares-Adicionados'] == '' ? '' : dadosTabelaNutricional.valueField['Acucares-Adicionados']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Acucares-Adicionados'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Acucares-Adicionados']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Acucares-Adicionados'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Acucares-Adicionados']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name">Proteínas (g)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Proteinas'] == '' ? '' : dadosTabelaNutricional.valueField['Proteinas']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Proteinas'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Proteinas']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Proteinas'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Proteinas']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name">Gorduras totais (g)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Gorduras-Totais'] == '' ? '' : dadosTabelaNutricional.valueField['Gorduras-Totais']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Gorduras-Totais'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Gorduras-Totais']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Gorduras-Totais'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Gorduras-Totais']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name sub-value-name">Gorduras saturadas (g)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Gorduras-Saturadas'] == '' ? '' : dadosTabelaNutricional.valueField['Gorduras-Saturadas']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Gorduras-Saturadas'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Gorduras-Saturadas']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Gorduras-Saturadas'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Gorduras-Saturadas']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name sub-value-name">Gorduras trans (g)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Gorduras-Trans'] == '' ? '' : dadosTabelaNutricional.valueField['Gorduras-Trans']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Gorduras-Trans'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Gorduras-Trans']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Gorduras-Trans'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Gorduras-Trans']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name">Fibras alimentares (g)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Fibra-Alimentar'] == '' ? '' : dadosTabelaNutricional.valueField['Fibra-Alimentar']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Fibra-Alimentar'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Fibra-Alimentar']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Fibra-Alimentar'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Fibra-Alimentar']}</td>
            </tr>
            <tr>
                <td colspan="3" class="value-name">Sódio (mg)</td>
                <td class="value-field value-field-porcao">${dadosTabelaNutricional.valueField['Sodio'] == '' ? '' : dadosTabelaNutricional.valueField['Sodio']}</td>
                <td class="value-field value-field-vt">${dadosTabelaNutricional.valueFieldVT['Sodio'] == '' ? '' : dadosTabelaNutricional.valueFieldVT['Sodio']}</td>
                <td class="value-field value-field-vd">${dadosTabelaNutricional.valueFieldVD['Sodio'] == '' ? '' : dadosTabelaNutricional.valueFieldVD['Sodio']}</td>
            </tr>
        </tbody>
          <tfoot>
              <tr>
                  <td colspan="5">
                    ${dadosTabelaNutricional.valueFieldInfoAnexada["Informacoes-Anexadas"]}
                  </td>
              </tr>
          </tfoot>
      </table>
    `);
      const $tableSwift = $(`
      <table>
          <thead>
              <tr>
                <th class="name-field-porcao border-bottom-0" colspan="100%">
                  <div>
                    <div>
                      Porção por Embalagem: ${dadosTabelaNutricionalEstilizada.valueFieldPorcao['Porcoes-Por-Embalagem'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldPorcao['Porcoes-Por-Embalagem']}
                    </div>
                    <div>
                      Porção: ${dadosTabelaNutricionalEstilizada.valueFieldPorcao["Tabela-Nutricional-Porcao"] == '' ? '' : `<span>${dadosTabelaNutricionalEstilizada.valueFieldPorcao["Tabela-Nutricional-Porcao"]}</span>`}
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th class="empty-field" colspan="1"></th>
                <th>${dadosTabelaNutricionalEstilizada.valueField["Peso-total-em-g"] == '' ? '' : `<span style="text-transform: Lowercase;">${dadosTabelaNutricionalEstilizada.valueField["Peso-total-em-g"]}</span>`}</th>

                <th class="name-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Peso-total-em-g'] == '' ? '' : `<span style="text-transform: Lowercase;">${dadosTabelaNutricionalEstilizada.valueFieldVT['Peso-total-em-g']}</span>`}</th>

                <th class="name-field-vd">%VD*</th>
              </tr>
          </thead>
          <tbody>
          <tr>
            <td class="name-field">Valor Energético <span style="text-transform: lowercase;">(kcal)</span></td>
            <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Valor-Energetico'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Valor-Energetico']}</td>
            <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Valor-Energetico'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Valor-Energetico']}</td>
            <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Valor-Energetico'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Valor-Energetico']}</td>
          </tr>
          <tr>
              <td class="name-field">Carboidratos <span style="text-transform: lowercase;">(g)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Carboidratos'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Carboidratos']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Carboidratos'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Carboidratos']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Carboidratos'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Carboidratos']}</td>
          </tr>
          <tr>
              <td class="name-field sub-name-field">Açúcares Totais <span style="text-transform: lowercase;">(g)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Acucares-Totais'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Acucares-Totais']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Acucares-Totais'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Acucares-Totais']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Acucares-Totais'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Acucares-Totais']}</td>
          </tr>
          <tr>
              <td class="name-field sub-name-field-2">Açúcares Adicionados <span style="text-transform: lowercase;">(g)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Acucares-Adicionados'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Acucares-Adicionados']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Acucares-Adicionados'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Acucares-Adicionados']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Acucares-Adicionados'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Acucares-Adicionados']}</td>
          </tr>
          <tr>
              <td class="name-field">Proteínas <span style="text-transform: lowercase;">(g)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Proteinas'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Proteinas']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Proteinas'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Proteinas']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Proteinas'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Proteinas']}</td>
          </tr>
          <tr>
              <td class="name-field">Gorduras Totais <span style="text-transform: lowercase;">(g)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Gorduras-Totais'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Gorduras-Totais']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Gorduras-Totais'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Gorduras-Totais']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Gorduras-Totais'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Gorduras-Totais']}</td>
          </tr>
          <tr>
              <td class="name-field sub-name-field">Gorduras Saturadas <span style="text-transform: lowercase;">(g)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Gorduras-Saturadas'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Gorduras-Saturadas']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Gorduras-Saturadas'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Gorduras-Saturadas']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Gorduras-Saturadas'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Gorduras-Saturadas']}</td>
          </tr>
          <tr>
              <td class="name-field sub-name-field">Gorduras Trans <span style="text-transform: lowercase;">(g)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Gorduras-Trans'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Gorduras-Trans']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Gorduras-Trans'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Gorduras-Trans']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Gorduras-Trans'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Gorduras-Trans']}</td>
          </tr>
          <tr>
              <td class="name-field">Fibras Alimentares <span style="text-transform: lowercase;">(g)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Fibra-Alimentar'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Fibra-Alimentar']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Fibra-Alimentar'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Fibra-Alimentar']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Fibra-Alimentar'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Fibra-Alimentar']}</td>
          </tr>
          <tr>
              <td class="name-field">Sódio <span style="text-transform: lowercase;">(mg)</span></td>
              <td class="value-field value-field-porcao">${dadosTabelaNutricionalEstilizada.valueField['Sodio'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueField['Sodio']}</td>
              <td class="value-field value-field-vt">${dadosTabelaNutricionalEstilizada.valueFieldVT['Sodio'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVT['Sodio']}</td>
              <td class="value-field value-field-vd">${dadosTabelaNutricionalEstilizada.valueFieldVD['Sodio'] == '' ? '' : dadosTabelaNutricionalEstilizada.valueFieldVD['Sodio']}</td>
          </tr>
          </tbody>
          <tfoot>
                <tr><td colspan="4" class="p-3"><span>${dadosTabelaNutricionalEstilizada.valueFieldInfoAnexada['Informacoes-Anexadas']}</span></td></tr>
          </tfoot>
      </table>
    `);

    console.log("📒 Informação Nutricional", {dadosTabelaNutricionalEstilizada, dadosTabelaNutricional});

      const $comp = $('.rnk-tabela-nutricional');
      if (verificaCamposPreenchidos(dadosTabelaNutricional) == true && verificaCamposPreenchidos(dadosTabelaNutricionalEstilizada) == true) {


        $comp.addClass('rnk-tabela-nutricional-swift');
        $('.rnk-tabela-nutricional-swift').before('<h2 class="rnk-tabela-nutricional-swift-titulo">Informação Nutricional</h2>')
        $('.rnk-tabela-nutricional-swift').removeClass('rnk-tabela-nutricional');
        $('.rnk-tabela-nutricional-swift').removeClass('d-none');
        $('.rnk-tabela-nutricional-swift').find('h2').remove();
        $('.rnk-tabela-nutricional-swift').html($tableSwift);

        if (dadosTabelaNutricionalEstilizada.valueFieldInfoAnexada["Informacoes-Anexadas"] == '') {
          $('.rnk-tabela-nutricional-swift tfoot').addClass('d-none');
        };

        if (dadosTabelaNutricionalEstilizada.valueFieldVT['Peso-total-em-g'] == '') {
          $('.rnk-tabela-nutricional-swift thead .name-field-vt').addClass('d-none');
          $('.rnk-tabela-nutricional-swift tbody .value-field-vt').addClass('d-none')
        }

        if ($('.rnk-tabela-nutricional-swift').parent().hasClass('col-md-6')) {
          $('.rnk-tabela-nutricional-swift').parent().removeClass('col-md-6').addClass('col-lg-6');
          $('.rnk-tabela-nutricional-swift').parent().siblings().removeClass('col-md-6').addClass('col-lg-6');
        }

      } else if (verificaCamposPreenchidos(dadosTabelaNutricional) == false && verificaCamposPreenchidos(dadosTabelaNutricionalEstilizada) == true) {

        $comp.addClass('rnk-tabela-nutricional-swift');
        $('.rnk-tabela-nutricional-swift').before('<h2 class="rnk-tabela-nutricional-swift-titulo">Informação Nutricional</h2>')
        $('.rnk-tabela-nutricional-swift').removeClass('rnk-tabela-nutricional');
        $('.rnk-tabela-nutricional-swift').removeClass('d-none');
        $('.rnk-tabela-nutricional-swift').find('h2').remove();
        $('.rnk-tabela-nutricional-swift').html($tableSwift);

        if (dadosTabelaNutricionalEstilizada.valueFieldInfoAnexada["Informacoes-Anexadas"] == '') {
          $('.rnk-tabela-nutricional-swift tfoot').addClass('d-none');
        };

        if (dadosTabelaNutricionalEstilizada.valueFieldVT['Peso-total-em-g'] == '') {
          $('.rnk-tabela-nutricional-swift thead .name-field-vt').addClass('d-none');
          $('.rnk-tabela-nutricional-swift tbody .value-field-vt').addClass('d-none')
        }

        if ($('.rnk-tabela-nutricional-swift').parent().hasClass('col-md-6')) {
          $('.rnk-tabela-nutricional-swift').parent().removeClass('col-md-6').addClass('col-lg-6');
          $('.rnk-tabela-nutricional-swift').parent().siblings().removeClass('col-md-6').addClass('col-lg-6');
        }

      } else if (verificaCamposPreenchidos(dadosTabelaNutricional) == true && verificaCamposPreenchidos(dadosTabelaNutricionalEstilizada) == false) {
        $comp.removeClass('d-none');
        $comp.append($table);

        if (dadosTabelaNutricional.valueFieldVT['Peso-total-em-g'] == '') {
          // Caso a tabela não apresente Valores Totais
          $($comp).addClass('tabela-nutricional-2c');
          $comp.find('.name-field-vt').addClass('d-none');
          $comp.find('.value-field-vt').addClass('d-none');
        } else {
          // Caso tabela possua a coluna de Valores Totais
          $comp.find('th.name-field-porcoes').attr('colspan', '7');
          $comp.find('.name-field-qtd-por-porcao').attr('colspan', '4');
          $comp.find('td.value-name').attr('colspan', '4');
          $comp.find('tfoot td').attr('colspan', '7');
        }

        if (dadosTabelaNutricional.valueFieldInfoAnexada["Informacoes-Anexadas"] == '') {
          $comp.find('tfoot').addClass('d-none');
        }
    };
    } catch (error) {
      console.log(`Erro na Tabela Nutricional: ${error}`);
    }
  };

  /**
   * Adicionar classe no body para facilitar a customização com base no tipo de unidade de medida do produto
   */
  const measureTypeBodyClass = () => {
    measureType = window.storeTheme.helpers.text.kebabCase(
      $productSpecification.find('.value-field.Unidade-de-Medidas').text().trim().toLowerCase(),
    );
    measureType.length && measureType.indexOf('kg') > -1
      ? $body.addClass('has-measure-kg')
      : $body.addClass(`has-measure-${measureType}`);
  };

  /**
   * Faz os cálculos de preços quando for o tipo de unidade de medida KG
   * @returns
   */
  const calcSkuMaxPrice = () => {
    if (window.skuJson && measureType.indexOf('kg') > -1) {
      // essa loja sempre tem apenas um SKU para cada produto.
      const { unitMultiplier, bestPrice } = window.skuJson.skus[0];

      const maxPrice = (bestPrice * unitMultiplier) / 100;

      const maxPriceCultureCode = maxPrice.toLocaleString(window.localeInfo.CultureCode, {
        minimumFractionDigits: 2,
        maximumSignificantDigits: 4,
      });
      const maxPriceFormated = `${window.localeInfo.CurrencyLocale.CurrencySymbol} ${maxPriceCultureCode}`;
      return { maxPrice, maxPriceFormated };
    }
  };

  /**
   * Adiciona as customizações de HTML no bloco de detalhes do produto
   */
  const setupContentBlocks = () => {
    // apresentação de informações relacionadas ao tipo de unidade de medida, próximo ao preço do produto
    const basedOnUnity = () => {
      const $skuPriceArea = $('#sku-price-area');
      const $price = $skuPriceArea.find('.skuBestPrice').text();
      $skuPriceArea.find('.product-sku-price .numero').text($price);

      // se for do tipo KG, precisa apresentar informação de preço variável
      if (measureType.indexOf('kg') > -1) {
        const maxPrice = calcSkuMaxPrice();
        $skuPriceArea.find('#product-max-price').text(maxPrice.maxPriceFormated);
      }
      // caso contrário
      else {
        const $productUnity = $('.rnk-descricao-produto .product-unity');
        $productUnity
          .find('.value')
          .html($productSpecification.find('.value-field.Quantidade-dentro-da-unidade-de-medida').html());
        $productUnity.removeClass('d-none');
      }
    };

    // Apresenta o valor para a parte da tela onde é apresentado o elemento com título "Importante"
    const fieldImportant = () => {
      const fieldAtencaoText = $productSpecification.find('.value-field.Atencao').text();

      if (fieldAtencaoText.length) {
        const $rnkAvisosContent = $('.rnk-avisos');
        const $rnkAvisosUl = $rnkAvisosContent.find('ul');
        $rnkAvisosUl.append(`<li>${fieldAtencaoText}</li>`);
        $rnkAvisosContent.removeClass('d-none');
      }
    };

    // Informações que estão no bloco de collapse abaixo do botão comprar principal do produto
    const collapsesInformation = () => {
      const fieldsOfCollapses = [
        'Modo de Preparo',
        'Dica de Preparo',
        'Dicas do Chef',
        'Rastreabilidade',
        'Vídeo',
        'Avaliações',
      ];

      const $fields = $productSpecification.find('.name-field');
      const template = $('#accordionMoreInfo script[type="text/template"]').text();

      if (!template) {
        console.warn('🥩 Template para acordion de informações complementares não está disponível nesta página');
        return false;
      }

      window.storeTheme.helpers.mustache.parse(template);

      const htmlDescription = $(`<div>${$('script#productDescription').text()}</div>`)
        .find('.productDescription')
        .html();

      let content = '';

      if (htmlDescription) {
        content += window.storeTheme.helpers.mustache.render(template, {
          id: window.storeTheme.helpers.text.kebabCase('Mais informações'),
          title: 'Mais informações',
          description: htmlDescription.indexOf('<p>') > -1 ? htmlDescription : `<p>${htmlDescription}</p>`,
        });
      }

      $fields.each((i, e) => {
        const $e = $(e);
        const title = $e.text().trim();
        if (fieldsOfCollapses.includes(title)) {
          const $html = $e.siblings('.value-field');
          const $iframe = $html.find('iframe');
          if ($iframe.length) {
            $iframe.addClass('embed-responsive-item');
          }

          let html = $html.html();
          if (html.indexOf('iframe') > -1) {
            html = `<div class="embed-responsive embed-responsive-16by9">${html}</div>`;
          }
          content += window.storeTheme.helpers.mustache.render(template, {
            id: window.storeTheme.helpers.text.kebabCase(title),
            title,
            description: html.indexOf('<p>') > -1 ? html : `<p>${html}</p>`,
          });
        }
      });

      if (content) {
        $('.rnk-componente-informacoes-do-produto').removeClass('d-none');
        $('#accordionMoreInfo').html(content).find('.accordion-item:eq(0) .collapse').attr('class', 'collapse show');
      }
    };

    const prodInfoAlergeticos = () => {
      const $box = $('.prod-info.info-alergicos');
      const values = [];
      const $values = $productSpecification.find('.group.Alergicos th.name-field').map((i, e) => {
        const $name = $(e);
        const $values = $name.siblings('td.value-field');
        values.push(['<li>', $name.text(), ' ', $values.text(), '.</li>'].join(''));
      });

      if (values.length) {
        $box.find('ul').html(values.join(''));
        $box.removeClass('d-none');
      }
    };

    // Adiciona selos de alerta (açucar,gordura saturada,sódio)
    const prodInfoSelos = () => {
      const $box = $('.prod-info.info-selos');
      const values = [];
      const $wrap = $productSpecification.find('table.group.Caracteristicas');
      const $selos = $wrap.find('.value-field.Selos').map((i, e) => {
        const items = e.innerText.split(',');
        const itemsVal = items.values();
        for (let selo of itemsVal) {
          values.push([`<li class="item ${selo.replace(/\s/g, '')}">${selo}</li>`].join(''));
        }
        if (values.length) {
          $box.find('ul').html(values.join(''));
          $box.removeClass('d-none');
        }
      });
    };

    const prodInfoConservacao = () => {
      try {
        const tabelaConservacao = $('.prod-info.info-conservacao');
        tabelaConservacao.addClass('rnk-tabela-conservacao');
        
        if (tabelaConservacao.find('table')) {
          tabelaConservacao.find('table').remove();
        }

        // RNK DANOS TABELA DE CONSERVAÇÃO
        let temperaturaCongelador = $productSpecification.find(".group.Modo-de-conservacao .value-field.Temperatura-para-conservacao-em-congelador").text();
        let validadeCongelador = $productSpecification.find(".group.Modo-de-conservacao .value-field.Validade-se-conservado-em-congelador").text();
        let validadeCongeladorEmbalagemAberta = $productSpecification.find(".group.Modo-de-conservacao .value-field.Validade-se-conservado-em-congelador-embalagem-aberta-").text();

        let temperaturaGeladeira = $productSpecification.find(".group.Modo-de-conservacao .value-field.Temperatura-para-conservacao-em-geladeira").text();
        let validadeGeladeira = $productSpecification.find(".group.Modo-de-conservacao .value-field.Validade-se-conservado-em-geladeira").text();
        let validadeGeladeiraEmbalagemAberta = $productSpecification.find(".group.Modo-de-conservacao .value-field.Validade-se-conservado-em-geladeira-embalagem-aberta-").text();


        let temperaturaFreezer = $productSpecification.find(".group.Modo-de-conservacao .value-field.Temperatura-para-conservacao-em-freezer").text();
        let validadeFreezer = $productSpecification.find(".group.Modo-de-conservacao .value-field.Validade-se-conservado-em-freezer").text();      
        let validadeFreezerEmbalagemAberta = $productSpecification.find(".group.Modo-de-conservacao .value-field.Validade-se-conservado-em-freezer-embalagem-aberta-").text();

        let infoConservacao = {
          Freezer: {
            ["Temperatura"]: temperaturaFreezer,
            ["Validade Embalagem Fechada"]: validadeFreezer,
            ["Validade Embalagem Aberta"]: validadeFreezerEmbalagemAberta 
          },
          Congelador: {
            ["Temperatura"]: temperaturaCongelador,
            ["Validade Embalagem Fechada"]: validadeCongelador,
            ["Validade Embalagem Aberta"]: validadeCongeladorEmbalagemAberta 
          },
          Geladeira: {
            ["Temperatura"]: temperaturaGeladeira,
            ["Validade Embalagem Fechada"]: validadeGeladeira,
            ["Validade Embalagem Aberta"]: validadeGeladeiraEmbalagemAberta 
          } 
        }
        console.log("📒 Informação Conservação", infoConservacao);

        let tabela = `
          <h2>Conservação Doméstica</h2>
          <table>
              <thead>
                  <tr>
                      <th>
                          <div>
                              <div>Dentro do prazo de validade.</div>
                              <div>Consumir em até:</div>
                          </div>
                      </th>
                      <th>
                          <div>Embalagem <span class="d-block">Fechada</span></div>
                      </th>
                      <th>
                          <div>Embalagem <span class="d-block">Aberta</span></div>
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr class="rnk-freezer-conservacao-tr">
                      <td>${temperaturaFreezer}</td>
                      <td>${validadeFreezer}</td>
                      <td>${validadeFreezerEmbalagemAberta}</td>
                  </tr>
                  <tr class="rnk-congelador-conservacao-tr">
                      <td>${temperaturaCongelador}</td>
                      <td>${validadeCongelador}</td>
                      <td>${validadeCongeladorEmbalagemAberta}</td>
                  </tr>
                  <tr class="rnk-geladeira-conservacao-tr">
                      <td>${temperaturaGeladeira}</td>
                      <td>${validadeGeladeira}</td>
                      <td>${validadeGeladeiraEmbalagemAberta}</td>
                  </tr>
              </tbody>
              <tfoot>
                  <tr>
                      <td colspan="3">
                          <div>
                              Uma vez descongelado, não voltar a congelar.
                          </div>
                      </td>
                  </tr>
              </tfoot>
          </table>
        `;

        tabelaConservacao.html(tabela);
        tabelaConservacao.removeClass('d-none');

        if(temperaturaFreezer == "") {
          $('.rnk-freezer-conservacao-tr').addClass('d-none');
        }
        if(temperaturaCongelador == "") {
          $('.rnk-congelador-conservacao-tr').addClass('d-none');
        }
        if(temperaturaGeladeira == "") {
          $('.rnk-geladeira-conservacao-tr').addClass('d-none');
        }
        if(temperaturaFreezer == "" && temperaturaCongelador == "" && temperaturaGeladeira == "") {
          tabelaConservacao.addClass('d-none');
        }
      } catch (error) {
        console.log(error);
      }
    };

    const prodInfoIngredientes = () => {
      const $box = $('.prod-info.info-ingredientes');
      const $td = $productSpecification.find('.group.Pagina-de-Produto--Descricao td.value-field.Ingredientes');
      if ($td.length) {
        let text = $td.html();
        if (text.indexOf('<p>') === -1) {
          text = `<p>${text}</p>`;
        }
        $box.find('.description').html(text);
        $box.removeClass('d-none');
      }
    };
    const isEmptyProd = () => {
      if (!window.skuJson.available) {
        $('body').addClass('available-false');
      }
    };

    basedOnUnity();
    fieldImportant();
    collapsesInformation();
    prodInfoAlergeticos();
    prodInfoSelos();
    prodInfoConservacao();
    prodInfoIngredientes();
    isEmptyProd();
  };

  const identifyProductSwifteVoce = () => {
    try { 
        $('div[data-track-shelf-pid]').each((i, item) => {

          let productId = $(item).attr('data-track-shelf-pid');
          window.storeTheme.helpers.getSkuInfoByProductList([productId], 'productId').then((objectProducts) => {
              Object.values(objectProducts).forEach((product) => {
                  if (product.productClusters?.['1106']) {
                        if ($('div[data-track-shelf-pid] .rnk-card-valor .rnk-flag-swift-e-voce').length < 1) {
                            $('div[data-track-shelf-pid] .rnk-card-valor').append('<div class="rnk-flag-swift-e-voce"></div>')
                        }

                        $(item).addClass('rnk-produto-swift-e-voce');

                        $(item).find('.rnk-card-inf').html(`R$${product["Preco Swift"][0]}`);

                        $(item).find('.rnk-flag-swift-e-voce').html(`
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 6C12 5.11641 11.4445 4.36172 10.6617 4.06875C11.0062 3.30938 10.868 2.38359 10.2422 1.75781C9.61641 1.13203 8.69063 0.99375 7.93125 1.33828C7.63828 0.555469 6.88359 0 6 0C5.11641 0 4.36172 0.555469 4.06875 1.33828C3.30938 0.99375 2.38125 1.13203 1.75781 1.75781C1.13203 2.38359 0.99375 3.30938 1.33828 4.06875C0.555469 4.36172 0 5.11641 0 6C0 6.88359 0.555469 7.63828 1.33828 7.93125C0.99375 8.69063 1.13203 9.61875 1.75781 10.2422C2.38125 10.8656 3.30703 11.0086 4.06875 10.6617C4.36172 11.4422 5.11641 12 6 12C6.88359 12 7.63828 11.4445 7.93125 10.6617C8.69531 11.0086 9.61875 10.8656 10.2422 10.2422C10.868 9.61641 11.0062 8.69063 10.6617 7.93125C11.4445 7.63828 12 6.88359 12 6ZM4.5 3.75C4.91414 3.75 5.25 4.08586 5.25 4.5C5.25 4.91414 4.91414 5.25 4.5 5.25C4.08586 5.25 3.75 4.91414 3.75 4.5C3.75 4.08586 4.08586 3.75 4.5 3.75ZM4.78781 8.00742C4.64133 8.15391 4.40391 8.15391 4.25742 8.00742L3.99234 7.74234C3.84586 7.59586 3.84586 7.35844 3.99234 7.21195L7.21195 3.99234C7.35844 3.84586 7.59586 3.84586 7.74234 3.99234L8.00742 4.25742C8.15391 4.40391 8.15391 4.64133 8.00742 4.78781L4.78781 8.00742ZM7.5 8.25C7.08586 8.25 6.75 7.91414 6.75 7.5C6.75 7.08586 7.08586 6.75 7.5 6.75C7.91414 6.75 8.25 7.08586 8.25 7.5C8.25 7.91414 7.91414 8.25 7.5 8.25Z" fill="#73014F"/>
                            </svg>
                            <div>Swift e Você</div>
                        `)
                    }
                })
            })
        });
    } catch (e) {
        console.log(e);
    }
  }

  const identifyProductSwifteVocePrice = () => {
    try {
        if($('.rnk-descricao-produto .preco-swift-e-voce-2').length > 0) {            
            $('.rnk-preco').find('.numero').addClass('rnk-preco-swift-e-voce');
        }
    } catch (error) {
        console.log(error);
    }
  }
  

  const buyTogether = () => {
    const $compBuyTogether = $($('script#comp-BuyTogether').text());
    const $box = $('.rnk-container-prateleira-compre-junto');
    const $containerItems = $box.find('ul');
    const $linksToBuy = $compBuyTogether.find('p.comprar-junto a');
    let skus = [];
    $linksToBuy.each((i, e) => {
      const $e = $(e);
      const href = $e.attr('href');
      const props = window.storeTheme.helpers.url.getJsonFromUrl(href, true);
      if (props?.sku) {
        skus = skus.concat(props.sku.filter((sku) => `${sku}` !== `${skuJson.skus[0].sku}`));
      }
    });

    if (!skus.length) {
      return;
    }
    skus.unshift(window.skuJson.skus[0].sku);
    $box.removeClass('d-none');

    // Quando o evento indicando que o bloco de compre junto foi exibido
    $(window).on('loadBuyTogether.storeTheme', async () => {
      // buscar o HTML de itens da prateleira
      const $html = $(
        await window.storeTheme.helpers.getShelfItemsHtml(skus, {
          templateId: 'a4a3d84b-838f-4e66-98a8-7a86c220bd2b',
        }),
      );

      const $boxBuyTogether = $('.rnk-componente-comprar-junto');

      // filtrar os itens retornados
      const $current = $html.find(`[data-track-shelf-sid="${window.skuJson.skus[0].sku}"]`).closest('[layout]');
      const $products = $html.find('li[layout]').not($current);

      if (!$products.length) {
        $box.addClass('d-none');
        console.warn('🥩 Não existem compre-junto configurado para essa página.');
        return;
      }

      // já deixa preparado os valores totais de compre junto
      $products.each((i, e) => {
        const $e = $(e);
        const url = $e.find('.BottomBuy a').attr('href');
        if (!url) {
          return false;
        }
        const urlParsed = window.storeTheme.helpers.url.getJsonFromUrl(url);
        const single = urlParsed.price / 100;
        const together = single + window.skuJson.skus[0].bestPrice / 100;

        $e.data('priceBuyTogether', {
          single,
          together,
          formated: window.storeTheme.helpers.format.money(together),
          skuId: urlParsed.sku,
          sc: urlParsed.sc,
          seller: urlParsed.seller,
        });
      });

      // monta o bloco de slider de produtos
      const $slider = $(`<li class="splide slider-buytogether" />`).html(
        $('<div class="splide__track">').html(
          $('<ul class="splide__list buytogether-group" />').html($products.addClass('splide__slide')),
        ),
      );

      // adiciona no DOM
      $containerItems.prepend([$current, $slider]);

      // Criar o objeto de slider
      const slider = window.storeTheme.helpers.slider('.slider-buytogether', {
        perPage: 1,
        autoHeight: true,
      });

      // Ativa update de preço quando o produto foi alterado
      slider.on('mounted', () => {
        $boxBuyTogether.find('.value').html($products.eq(0).data('priceBuyTogether').formated);
        $boxBuyTogether.find('button').data('buytogether', {
          skus: [window.skuJson.skus[0].sku, $products.eq(0).data('priceBuyTogether').skuId],
          seller: $products.eq(0).data('priceBuyTogether').seller,
          sc: $products.eq(0).data('priceBuyTogether').sc,
        });
      });
      slider.on('moved', (newIndex) => {
        $boxBuyTogether.find('.value').html($products.eq(newIndex).data('priceBuyTogether').formated);
        $boxBuyTogether.find('button').data('buytogether', {
          skus: [window.skuJson.skus[0].sku, $products.eq(newIndex).data('priceBuyTogether').skuId],
          seller: $products.eq(newIndex).data('priceBuyTogether').seller,
          sc: $products.eq(newIndex).data('priceBuyTogether').sc,
        });
      });

      slider.mount();

      $boxBuyTogether.find('button').on('click', async (event) => {
        event.preventDefault();
        const $btn = $(event.currentTarget);
        const btnHtml = $btn.html();
        const data = $btn.data('buytogether');
        $btn.prop('disabled', true);
        $btn.html(window.storeTheme.helpers.loader.getHtmlLoader());
        try {
          await vtexjs.checkout.addToCart(
            data.skus.map((id) => ({
              id,
              quantity: 1,
              seller: data.seller,
            })),
            null,
            data.sc,
          );
        } catch (e) {
          console.error(e);
        }

        $btn.prop('disabled', false);
        $btn.html(btnHtml);
        $(window).trigger('openWidgetCart');
      });

      // Adiciona classe para ser utilizada em situação visual
      $slider.addClass('slider-ready');

      // Ativa trigger para ajustar customização de prateleira
      $(window).trigger('shelf.newItemsLoaded');

      identifyProductSwifteVoce();
    });
  };
  const customFlagPdp = async (prodId: Number) => {
    const $flagComponent = $('.rnk-componente-flags');
    const $flagCustomContainer = $flagComponent.find('.custom-flag-pdp');
    const $flagHightlight = $flagComponent.find('.flag-hightlight');
    const collectionId = $flagCustomContainer.data('collection') || '';
    const prodInfo =
      (await (
        await fetch(`/api/catalog_system/pub/products/search/?sc=${
          window.storeTheme.salesChannelSelector.getSalesChannel()
        }&fq=skuId:${prodId}`)
      ).json()) || '';
    const prodCollections = prodInfo[0]?.productClusters;
    if (prodInfo.length > 0) {
      Object.entries(prodCollections).map((item) => {
        if (item[0] == collectionId) {
          const nameCollection = (item[1] as string).toLowerCase().split(' ').join('-');
          const nameCollectionNormalize = nameCollection.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          if ($flagHightlight.find(`.${nameCollectionNormalize}`)) {
            $flagHightlight.find(`.${nameCollectionNormalize}`).addClass('d-none');
          }
          $flagCustomContainer.removeClass('d-none');
        } else {
          return false;
        }
      });
    }
    $flagHightlight.removeClass('d-none');
  };

  init();
};

handleProductLayout();

export default {};
